export enum MutationTypes {
  SET_USER_STATUS = "SET_USER_STATUS",
  SET_REQUEST_PASSWORD_RESET_STATUS = "SET_REQUEST_PASSWORD_RESET_STATUS",
  SET_REGISTER_VALIDATION_STATUS = "SET_REGISTER_VALIDATION_STATUS",
  SET_REGISTER_STATUS = "SET_REGISTER_STATUS"
}
